import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestTmppay } from "../../entity/EntityRequestTmppay";

export class DtoRequestTmppaysGetRes extends EntityRequestTmppay {
  public items: EntityRequestTmppay[]  = [];
}
